import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { AuthService, CmsBannerComponent, CmsService, SemanticPathService, User } from "@spartacus/core";
import { BannerComponent, CmsComponentData } from "@spartacus/storefront";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { BehaviorSubject, Observable, Subscription, combineLatest, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { SiteService } from "../../../services/site.service";

@Component({
  selector: 'app-custom-site-logo',
  templateUrl: './custom-site-logo.component.html',
  styleUrls: ['./custom-site-logo.component.scss'],
  standalone: false
})
export class CustomSiteLogoComponent extends BannerComponent implements AfterViewInit, OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  protected user$: Observable<User | undefined>;
  protected visible$ = new BehaviorSubject<boolean>(false);
  public visible = this.visible$.asObservable();

  constructor(
    protected component: CmsComponentData<CmsBannerComponent>,
    protected urlService: SemanticPathService,
    protected cmsService: CmsService,
    private siteService: SiteService,
    private auth: AuthService,
    private userAccount: UserAccountFacade
  ) {
    super(component, urlService, cmsService);
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccount.get();
        } else {
          return of(undefined);
        }
      })
    );
  }

  ngAfterViewInit(): void {
    const tasks$: Observable<[User, string]> = combineLatest([this.user$, this.siteService.currentSite]);

    this.subscriptions.add(tasks$.subscribe(([user, currentSite]: [User, string]) => {
      this.isVisible(currentSite, user);
    }));
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  private isVisible(site: string, user: User): void {
    let isVisible: boolean = false;

    if (this.styleClasses?.indexOf('chefsarea') >= 0 && site === 'chefsarea' && ((user?.professional && !user?.consumer) || typeof user === 'undefined')) {
      isVisible = true;
    } else if (this.styleClasses?.indexOf('ohgar') >= 0 && site === 'ohgar') {
      isVisible = true;
    } else if (this.styleClasses?.indexOf('outlet') >= 0 && site === 'outlet') {
      isVisible = true;
    }
    this.visible$.next(isVisible);
  }

}
